import { API_BASE_URL } from '../constants/suggestions';

/**
 * Fetch storage usage metrics from backend
 */
export const fetchStorageMetrics = async (token) => {
  const response = await fetch(`${API_BASE_URL}/api/storage/metrics`, {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  if (!response.ok) {
    const errorText = await response.text();
    throw new Error(errorText || `Failed to fetch storage metrics: ${response.status}`);
  }

  return response.json();
};
